import rbacPlugin from '@backstage-community/plugin-rbac';
import { createFrontendModule } from '@backstage/frontend-plugin-api';

const rbacPageOverride = rbacPlugin.getExtension('page:rbac').override({
  params: {
    noHeader: true,
  },
});

export const rbacPluginOverride = createFrontendModule({
  pluginId: 'rbac',
  extensions: [rbacPageOverride],
});
